<template>
  <div class="page-content homeworkPage">
    <!-- <div class="pageTitleBox d-flex d-flex-middle d-flex-between">
      <p class="pageTitle">学费订单</p>
    </div> -->
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
        <span class="newMine_pageTitles">学费订单</span>
      </p>
    <div class="content">
      <div v-if="list.length == 0" style="text-align: center;">暂无订单</div>
      <!-- <div class="li">
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">订单号：</p>
            <p class="color3">B60C7EED47B84970B3482D18B1A77542</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">学年：</p>
            <p class="color3">第1学年</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">金额：</p>
            <p class="color3" style="color: red; font-weight: bold;">998.00</p>
          </div>
        </div>
        <div class="btns">
          <el-button size="mini" class="my-btn" type="primary" @click="handlePay()">支付</el-button>
        </div>
      </div> -->
      <div class="li" v-for="(item,index) in list" :key="index">
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div v-if="item.orderNo" class="descLi d-flex d-flex-middle">
            <p class="color9">订单号：</p>
            <p class="color3">{{ item.orderNo }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">费用类型：</p>
            <p class="color3">第{{ item.yearTime }}学年学费</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">金额：</p>
            <p class="color3" style="color: red; font-weight: bold;">{{ item.money }}</p>
          </div>
        </div>
        <div v-if="item.refundStatus" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核状态：</p>
            <p class="color3">{{ item.refundStatus == 1 ? '退费成功' : '退费失败' }}</p>
          </div>
        </div>
        <div v-if="item.opinion" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核意见：</p>
            <p class="color3">{{ item.opinion }}</p>
          </div>
        </div>
        <div v-if="item.filePath" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核附件：</p>
            <p class="color3"><img :src="item.filePath" style="width: 80px; height: 80px;" alt=""></p>
          </div>
        </div>
        <div class="btns">
          <el-button size="mini" v-if="item.orderId && item.status == 'YZF'" class="my-btn" @click="handleDownload(item.orderId)">下载发票</el-button>
          <!-- <el-button size="mini" v-if="item.status == 'YZF' && !item.refundStatus && item.refundStatus != 0" class="my-btn" @click="handleBack(item.id)">申请退费</el-button> -->
          <el-button size="mini" type="danger" v-if="item.refundStatus == 0" class="my-btn" @click="handleCancel(item.refundId)">撤回申请</el-button>
          <el-button size="mini" v-if="item.status == 'WZF' || !item.status" class="my-btn" type="primary" @click="handlePay(item.orderId ,item.yearTime)">支付</el-button>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="form.size"
        :total="total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>

    <el-dialog title="申请退费" :visible.sync="dialogFormVisible">
      <el-form :model="refundForm" :rules="rules" ref="ruleForm">
        <el-form-item label="申请原因" prop="remark">
          <el-input v-model="refundForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="resetForm('ruleForm')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <PayDialog ref="payDialog" @refresh="getData" />

  </div>
</template>

<script>
import PayDialog from '@/components/bm/PayDialog.vue'

export default {
  components: {
    PayDialog
  },
  data() {
    return {
      studentInfo:{},
      list: [],
      form:{
        size: 10,
        current: 1,
      },
      total:0,
      orders: [],
      dialogFormVisible: false,
      refundForm: {
        id: '',
        remark: '',
      },
    rules: {
      remark: [
        { required: true, message: '请输入申请原因', trigger: 'blur' },
      ],
    }
  };
},
created() {
  this.loadStudentInfo()
},
  async mounted() {
    this.getData()
  },
  methods: {
    loadStudentInfo() {
      this.$http.get('/student/pc/getStudentInfo').then(res => {
        console.log(res);
        this.studentInfo = res
      })
    },
    handleDownload(orderId) {
      this.$http
        .get(`/student/pc/getInvoice/${orderId}`)
        .then((url) => {
          if (url) {
            window.open(url)
          }
        })
        .catch(() => {})
    },
    handleBack(id) {
      this.dialogFormVisible = true
      this.refundForm.id = id
    },
    handleCancel(id) {
      let _this = this
      this.$confirm('确定撤回申请吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('/student/pc/order/refund/remove/' + id).then((res) => {
          this.$message({
            type: 'success',
            message: '撤回成功!'
          });
          _this.getData()
        })
      })
    },
    async getData() {
      this.$http.get('/student/pc/order/myOrders',this.form).then((res) => {
        this.list = res.records
        this.total = res.total
      })
    },
    changePage(e){
      this.form.current = e
      this.getData();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.get('/student/pc/order/refund/apply',this.refundForm).then((res) => {
            this.getData()
            this.$message({
              type: 'success',
              message: '申请成功!'
            });
            this.resetForm('ruleForm')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false
    },
    detail(row){
      this.$router.push('/paperDetail?type=HOMEWORK&id='+row.paperId+'&examDataId='+row.examDataId+'&myScore='+row.score+'&examConfigId='+this.form.examConfigId)
    },
    handlePay(orderId, feeType) {
      if (orderId) {
        // 如果已有订单ID，获取订单详情
        this.$http.get('/student/pc/studyFee/order/getDetail/' + orderId).then(res => {
          // 将订单详情传递给PayDialog组件
          this.$refs.payDialog.open({
            id: res.id,
            orderNo: res.orderNo,
            cost: res.cost || res.money,
            yearTime: res.yearTime,
            createTime: res.createTime
          })
        })
      } else {
        // 如果没有订单ID，创建新订单
        this.$http.post('/student/pc/studyFee/order/create2/' + feeType,{
          studentId: this.studentInfo.id
        }).then(res => {
          // 将订单详情传递给PayDialog组件
          this.$refs.payDialog.open({
            id: res.id,
            orderNo: res.orderNo,
            cost: res.cost || res.money,
            yearTime: res.yearTime,
            createTime: res.createTime
          })
        })
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.btns {
		display: flex;
		justify-content: flex-end;
		font-size: 13px;

		.my-btn {
			// background: linear-gradient(-90deg, #7275f6, #6eadf8);
			// padding: 6px 10px;
			// border: 6px;
			// color: #fff;
			// border-radius: 6px;
			margin-left: 10px;
		}
	}
.txtOver {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.homeworkPage{
  .pageTitleBox{
    height: 80px;
    box-sizing: border-box;
    padding: 0 30px;
    .pageTitle{
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
    .mb0{
      margin-bottom: 0;
    }
  }
  .tabs {
    width: 100%;
    height: 40px;
    background: $primary;
    p {
      width: 80px;
      text-align: center;
      margin: 0 30px;
      font-size: 16px;
      cursor: pointer;
      line-height: 40px;
      position: relative;
      color: rgb(51, 51, 51);
    }

    i {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 4px;
      background-color: transparent;
      background: transparent;
    }

    .on {
      color: $primary;
    }

    .bgColor {
      background: $primary;
    }
  }
  .content{
    box-sizing: border-box;
    padding: 0 50px;
    min-height: 450px;
    .li{
      width: 100%;
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      padding: 20px 0;
      .topLi{
        margin-bottom: 10px;
        .icon{
          width: 18px;
          height: 18px;
          margin-right: 5px;
          position: relative;
          top: 2px;
        }
        .name{
          font-size: 16px;
          color: #333;
        }
        .score{
          height: 20px;
          line-height: 20px;
          background: #FFA800;
          color: #fff;
          border-radius: 10px;
          margin-left: 10px;
          text-align: center;
          box-sizing: border-box;
          padding: 0 5px;
          font-size: 13px;
        }
        .btns{
          font-size: 16px;
          p{
            margin-left: 20px;
          }
        }
      }
      .descBox{
        font-size: 14px;
        .descLi{
          margin-right: 50px;
        }
      }
    }
  }
  
  .pagination{
    display: flex;
    justify-content: center;
    align-content: center;
  }
}

.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

</style>
